import type { PersonalizedOnetimeBundle } from "@halm-club/halm-shared";
import "./IncludedProduct.css";

export type IncludedProductData =
  PersonalizedOnetimeBundle["onetimeSingleProducts"][number];

type IncludedProductProps = {
  index: number;
  product: IncludedProductData;
};

export function IncludedProduct({ index, product }: IncludedProductProps) {
  const content = (
    <>
      <div className="react-pdp__onetime-image-index-wrapper">
        <div className="react-pdp__onetime-included-image-wrapper">
          {product.imageSource ? (
            <img
              alt=""
              className="react-pdp__onetime-included-image"
              src={product.imageSource}
            />
          ) : null}
        </div>
        <span className="react-pdp__onetime-included-index">{index + 1}</span>
      </div>

      <div className="react-pdp__onetime-included-copy">
        <h3 className="react-pdp__onetime-included-title">{product.title}</h3>
        <p className="react-pdp__onetime-included-description">
          {product.description}
        </p>
      </div>
    </>
  );

  return (
    <li className="react-pdp__onetime-included-product">
      {product.href ? (
        <a
          className="react-pdp__onetime-included-product-row react-pdp__onetime-included-product-row--clickable"
          href={product.href}
        >
          {content}
        </a>
      ) : (
        <div className="react-pdp__onetime-included-product-row">
          {content}
        </div>
      )}
    </li>
  );
}
